import { DefaultTheme } from "styled-components";

const theme: DefaultTheme = {
  colors: {
    N00: '#fff',
    N100: '#edf1f2',
    N200: '#d6d6d6',
    N300: '#c5c5c5',
    N400: '#a0a0a0',
    N450: '#696969',
    N500: '#505050',
    N600: '#333333',
    N700: '#2e2e30',
    N800: '#1e1e1e',
    P100: '#e5cbf5',
    P300: '#cf7dff',
    P500: '#b94df7',
    P700: '#8835b8',
    R300: '#f28d5a',
    R500: '#ee6f2e',
    R700: '#9c481e',
  },
  animation: {
    normal: 'cubic-bezier(.6,0,.32,1)',
  },
};

export { theme };
